var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{ref:"file",class:_vm.validationClass,attrs:{"type":"file","id":"file","disabled":_vm.disabled},on:{"change":function($event){return _vm.handleFile()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }